var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bg-primary-100 p-4 rounded text-sm text-center desktop:text-left"
    },
    [
      _c("p", { staticClass: "text-gray-800" }, [
        _vm._v(" You were logged in with "),
        _c(
          "a",
          {
            staticClass: "font-medium hover:underline",
            attrs: { href: _vm.loginUrl, target: "_blank" }
          },
          [_vm._v(_vm._s(_vm.loginUrl))]
        )
      ]),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col-reverse items-center mt-4 desktop:flex-row desktop:justify-end"
        },
        [
          _c(
            "BaseLink",
            {
              staticClass: "mr-2",
              on: {
                click: function($event) {
                  return _vm.$emit("forget")
                }
              }
            },
            [_vm._v(" Forget it ")]
          ),
          _c(
            "BaseButton",
            {
              staticClass:
                "\n                border border-primary-500 text-sm text-primary-700 justify-center mb-4\n                hover:bg-black-overlay desktop:mb-0\n            ",
              on: {
                click: function($event) {
                  return _vm.$emit("login")
                }
              }
            },
            [_vm._v(" Log in again ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }